import React from "react";
import { Box, Container, Typography, } from "@mui/material";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const items = [
    {
        icon: <LocalShippingOutlinedIcon />,
        title: "Free Shipping",
        desc: "Fast & reliable delivery on all orders",
    },
    {
        icon: <ReplayOutlinedIcon />,
        title: "Satisfied or Refunded",
        desc: "Easy returns if you're not happy",
    },
    {
        icon: <SupportAgentOutlinedIcon />,
        title: "Top-notch Support",
        desc: "We’re here to help 24/7",
    },
    {
        icon: <LockOutlinedIcon />,
        title: "Secure Payments",
        desc: "100% safe & encrypted checkout",
    },
];

const FooterHighlights = () => {
    return (
        <Container maxWidth="lg">
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(4, 1fr)",
                    },
                    gap: {
                        xs: 3,
                        sm: 6,
                        md: 5,
                    },
                    py: { xs: 4, sm: 6, md: 2 }
                }}
            >
                {items.map((item, index) => (
                    <Box key={index}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 2,
                            }}
                        >
                            {/* Icon */}
                            <Box
                                sx={{
                                    color: "#d4a017",
                                    fontSize: 30,
                                    mt: "6px",
                                }}
                            >
                                {item.icon}
                            </Box>

                            {/* Text */}
                            <Box>
                                <Typography
                                    variant="subtitle1"
                                    fontWeight={600}
                                    color="text.primary"
                                >
                                    {item.title}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ mt: 0.5 }}
                                >
                                    {item.desc}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Container>
    );
};

export default FooterHighlights;
